const parseTrailerValue = (value) => {
  let parsed = value;

  // Some older rows were JSON encoded more than once.
  for (let attempt = 0; attempt < 2 && typeof parsed === "string"; attempt += 1) {
    try {
      parsed = JSON.parse(parsed || "[]");
    } catch {
      return [];
    }
  }

  if (Array.isArray(parsed)) return parsed;
  if (!parsed || typeof parsed !== "object") return [];

  // Accept either a single trailer object or an object keyed by row number.
  const keys = Object.keys(parsed);
  const isSingleTrailer = keys.some((key) =>
    ["number", "trailernumber", "trailerno", "type", "trailertype"].includes(
      key.toLowerCase().replace(/[^a-z0-9]/g, "")
    )
  );

  return isSingleTrailer ? [parsed] : Object.values(parsed);
};

export default function normalizeTrailers(value) {
  return parseTrailerValue(value)
    .filter((trailer) => trailer && typeof trailer === "object")
    .map((trailer) => {
      const fields = Object.fromEntries(
        Object.entries(trailer).map(([key, fieldValue]) => [
          key.toLowerCase().replace(/[^a-z0-9]/g, ""),
          fieldValue,
        ])
      );

      return {
        number: String(
          fields.number ?? fields.trailernumber ?? fields.trailerno ?? ""
        ),
        type: String(fields.type ?? fields.trailertype ?? ""),
      };
    });
}
